import React, { Component } from 'react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import TextField from 'material-ui/TextField';
import * as actions from '../../store/actions/index';
import { connect } from 'react-redux';
import { Field, reduxForm, change } from 'redux-form'
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import { Link } from 'react-router-dom';
import FlatButton from 'material-ui/FlatButton';
import { apiService } from '../../common/apiCallService';
import Loading from '../Loading.js';
import { baseUrl } from '../../common/config.js';

class AppUserFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      access: JSON.parse(localStorage.getItem('userRole')),
      playerSelected: true,
      open: false,
      loading: false,
      msg: ""
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.roles.length === 0 && this.props.roles.length !== 0) {
      this.props.change('roles', this.props.roles.map(role => role._id))
    }
    if (prevProps.businessList.length === 0 && this.props.businessList.length !== 0) {
      this.props.change('businessList', this.props.businessList.map(business => business._id))
    }
    if (prevProps.coachList.length === 0 && this.props.coachList.length !== 0) {
      this.props.change('coachList', this.props.coachList.map(coach => coach._id))
    }
    if (prevProps.playerTypeList.length === 0 && this.props.playerTypeList.length !== 0) {
      this.props.change('playerTypeList', this.props.playerTypeList.map(playerType => playerType._id))
    }
    let allData={}
    allData.roles=this.props.roles.map(role => role._id);
    allData.business= this.props.businessList.map(business => business._id);
    allData.coachList=this.props.coachList.map(coach => coach._id);
    allData.playerTypeList=this.props.playerTypeList.map(playerType => playerType._id);
    this.props.setInitialValues(allData);
  }
  
  renderSelectField = ({ input, label, meta: { touched, error }, children, ...custom }) => (
    <SelectField
      floatingLabelText={label}
      errorText={touched && error}
      {...input}
      onChange={(event, index, value) => {
        if (value.indexOf('All') != -1) {
          if ((value.length - 1) === this.props[input.name].length) return input.onChange([])
          else return input.onChange(this.props[input.name].map(role => role._id));
        } else return input.onChange(value);
      }}
      children={children}
      {...custom}
      multiple={true}
    />
  )

  onSearch = () => {
    const {
      username,
      first_name,
      last_name,
      alias,
      businessList,
      roles,
      coachList,
      playerTypeList
    } = this.props.AppUserFilter.values;

    this.props.onSearch({
      selectedRoles: roles ? roles : [],
      selectedBusiness: businessList ? businessList : [],
      selectedPlayerTypes: playerTypeList ? playerTypeList : [],
      selectedCoaches: coachList ? coachList : [],
      username,
      first_name,
      last_name,
      alias,
      pageNo: 1,
    });
    this.props.getUsersList();
  }

  uploadRangesAndCat = () => {
    this.setState({ loading: true })
    apiService(baseUrl + '/reportCard/uploadRangesAndCat', {
    }, (data) => {
      this.setState({ msg: data.msg })
      this.setState({ loading: false })
      this.handleOpen();

    }, (data) => {
      this.setState({ loading: false })
      if (data.status == 403) {
        this.props.setLogin()
      }
    })
  }

  uploadStartingHands = () => {
    this.setState({ loading: true })
    apiService(baseUrl + '/appUser/uploadFile', {
    }, (data) => {
      this.setState({ msg: data.msg })
      this.setState({ loading: false })
      this.handleOpen();

    }, (data) => {
      this.setState({ loading: false })
      if (data.status == 403) {
        this.props.setLogin()
      }
    })
  }

 
  renderTextField = ({ input, label, meta: { touched, error }, ...custom }) => {
    return (
      <TextField
        hintText={label}
        floatingLabelText={label}
        errorText={touched && error}
        {...input}
        {...custom}
      />
    )
  }

  handleOpen = () => {
    this.setState({ open: true });
  }

  handleClose = () => {
    this.setState({ open: false });
  }
  render() {
    const { roles, businessList, coachList, playerTypeList, } = this.props;
    const { playerSelected } = this.state;

    const actions = [
      <FlatButton
        label="Ok"
        primary={true}
        keyboardFocused={true}
        onClick={this.handleClose}
      />,
    ];
    return (
      <div>
        {this.state.loading ? <Loading /> : null}
        <div>
          <Dialog
            actions={actions}
            modal={false}
            open={this.state.open}
            onRequestClose={this.handleClose}
          >
            {this.state.msg}
          </Dialog>
        </div>
        {this.state.access.indexOf('SYS_ADMIN') !== -1
          ?
          <div>
            <div className="row">
              <RaisedButton label="Update Starting Hands " data-e2e="updatestarting" secondary={true} style={{ float: 'right' }} onTouchTap={() => this.uploadStartingHands()} />
            </div>
            <br />
            <div className="row">
              <RaisedButton label="Update Ranges " data-e2e="updateranges" secondary={true} style={{ float: 'right' }} onTouchTap={() => this.uploadRangesAndCat()} />
            </div>
          </div>
          : null}
        <br />
        <div className="row">
          <Link style={{ textDecoration: "none" }} to={'/newAppUser'}>
            <RaisedButton label="ADD NEW" data-e2e="addnew"secondary={true} style={{ float: 'right' }} />
          </Link>
        </div>
        <form className="form-inline">
          <div className="row">
            <div className="form-group col-sm-4 col-md-3 "data-e2e="selected-roles" >
              <Field name="roles" component={this.renderSelectField} label="Selected Roles">
                <MenuItem value='All' primaryText='All' />
                {roles.map((item, key) =>
                  <MenuItem key={key} insetChildren={true} checked={true} value={item._id} primaryText={item.authority} data-e2e={item.authority}/>
                )}
              </Field>
            </div>
            <div className="form-group col-sm-4 col-md-3"data-e2e="selected-business" >
              <Field name="businessList" component={this.renderSelectField} label="Selected Business">
                <MenuItem value='All' primaryText='All' />
                {businessList.map((item, key) =>
                  <MenuItem selected={true} insetChildren={true} checked={true} value={item._id} primaryText={item.business_name} data-e2e={item.business_name}/>
                )}
              </Field>
            </div>
            <div className="form-group col-sm-4 col-md-3" data-e2e="select-coach" >
              <Field name="coachList" component={this.renderSelectField} label="Selected Coach">
                <MenuItem value='All' primaryText='All' />
                {coachList.map((item, key) =>
                  <MenuItem selected={true} insetChildren={true} checked={true} value={item._id} primaryText={item.first_name + " " + item.last_name} data-e2e={item.first_name + " " + item.last_name} />
                )}
              </Field>
            </div>
            <div className="form-group col-sm-4 col-md-3" data-e2e="user-username">
              <Field
                name="username"
                component={this.renderTextField}
                label="Username"
              />
            </div>
          </div>
          <div className='row'>
            <div className="form-group col-sm-4 col-md-3" data-e2e="user-firstname">
              <Field
                data-e2e="searchFirstName"
                name="first_name"
                component={this.renderTextField}
                label="First Name"
              />
            </div>
            <div className="form-group col-sm-4 col-md-3" data-e2e="user-lastname">
              <Field
                name="last_name"
                component={this.renderTextField}
                label="Last Name"
              />
            </div>
            {playerSelected ?
              <div className="form-group col-sm-4 col-md-3" data-e2e="user-player-type">
                <Field name="playerTypeList" component={this.renderSelectField} label="Selected Player Type">
                  <MenuItem value='All' primaryText='All' />
                  {playerTypeList.map((item, key) =>
                    <MenuItem selected={true} insetChildren={true} checked={true} value={item._id} primaryText={item.player_Type} data-e2e={item.player_Type} />
                  )}
                </Field>
              </div> : null
            }
            {playerSelected ?
              <div className="form-group col-sm-4 col-md-3" data-e2e="user-alias">
                <Field
                  name="alias"
                  component={this.renderTextField}
                  label="Alias"
                />
              </div> : null
            }
          </div>
          <div className='row'>
            <div className="col-sm-4 col-md-3" data-e2e="user-search" style={{ paddingTop: "2%" }} >
              <RaisedButton
                data-e2e="searchBtn"
                label="SEARCH"
                primary={true}
                style={{ paddingBottom: "3%" }}
                onTouchTap={() => this.onSearch()}
              />
            </div>
          </div>
        </form>
      </div>

    );
  }
}

AppUserFilter = reduxForm({
  form: 'AppUserFilter'
})(AppUserFilter)

const mapStateToProps = state => {
  const {playerTypeList,roles,businessList,coachList}=state.userFormInitialValues; 
  return {
    roles: state.appUser.roles,
    businessList: state.appUser.business,
    coachList: state.appUser.coachList,
    playerTypeList: state.appUser.playerTypeList ,
    max: state.appUser.max,
    offset: state.appUser.offset,
    sortBy: state.appUser.sortBy,
    currColumn: state.appUser.currColumn,
    username: state.appUser.username,
    AppUserFilter: state.form.AppUserFilter,
    initialValues: {
      first_name: '',
      last_name: '',
      username: '',
      alias: '',
      roles:roles,
      businessList:businessList,
      coachList:coachList,
      playerTypeList:playerTypeList
    }
  };
};

const mapDispatchToProps = dispatch => {
  return {
    change: (field, value) => dispatch(change('AppUserFilter', field, value)),
    getUsersList: () => dispatch(actions.getUsersList()),
    onSearch: payload => dispatch(actions.onSearch(payload)),
    setInitialValues: (values) => dispatch(actions.setInitialValues(values)),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(AppUserFilter);



/** WEBPACK FOOTER **
 ** ./src/components/NewAppUser/AppUserFilter.js
 **/